import { render, staticRenderFns } from "./TeamPiece.vue?vue&type=template&id=744daa58&scoped=true&"
import script from "./TeamPiece.vue?vue&type=script&lang=js&"
export * from "./TeamPiece.vue?vue&type=script&lang=js&"
import style0 from "./TeamPiece.vue?vue&type=style&index=0&id=744daa58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744daa58",
  null
  
)

export default component.exports